import { render, staticRenderFns } from "./PageReportPUM.vue?vue&type=template&id=367a8271"
import script from "./PageReportPUM.vue?vue&type=script&lang=js"
export * from "./PageReportPUM.vue?vue&type=script&lang=js"
import style0 from "./PageReportPUM.vue?vue&type=style&index=0&id=367a8271&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports